import { ProtectedDocument } from '../types';
import { INITIAL_DOCUMENTS } from '../data/mockState';

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
const DOCS_STORAGE_KEY = 'idfraud_documents_list';

function getStoredDocs(): ProtectedDocument[] {
  const raw = localStorage.getItem(DOCS_STORAGE_KEY);
  if (raw) {
    try {
      return JSON.parse(raw);
    } catch {
      return INITIAL_DOCUMENTS;
    }
  }
  localStorage.setItem(DOCS_STORAGE_KEY, JSON.stringify(INITIAL_DOCUMENTS));
  return INITIAL_DOCUMENTS;
}

export async function getProtectedDocuments(): Promise<ProtectedDocument[]> {
  await delay(300);
  return getStoredDocs();
}

export async function addProtectedDocument(doc: Omit<ProtectedDocument, 'id' | 'lastChecked' | 'protectionStatus'>): Promise<ProtectedDocument> {
  await delay(400);
  const current = getStoredDocs();
  const newDoc: ProtectedDocument = {
    ...doc,
    id: 'doc-' + Math.random().toString(36).substring(2, 7),
    protectionStatus: 'protected',
    lastChecked: new Date().toISOString()
  };
  const updated = [...current, newDoc];
  localStorage.setItem(DOCS_STORAGE_KEY, JSON.stringify(updated));
  return newDoc;
}

export async function removeProtectedDocument(docId: string): Promise<ProtectedDocument[]> {
  await delay(300);
  const current = getStoredDocs();
  const updated = current.filter(d => d.id !== docId);
  localStorage.setItem(DOCS_STORAGE_KEY, JSON.stringify(updated));
  return updated;
}
